export default __webpack_public_path__ + "static/header.nht-6223a0b6e5770e0af6b0d269068da44a.png";